import {type FC, useCallback} from 'react';

import type {ClickTargetId, Props} from './types';

import {NotificationsListItemDumb} from '../NotificationsListItemDumb';
import {useController} from './controller';

export const NotificationsListItem: FC<Props> = props => {
  const {contexts, data} = useController(props);

  const onClickCb = useCallback(() => {
    props.onClick?.(props.event.type, props.event, contexts);
  }, [contexts, props]);

  const onButtonClickCb = useCallback(
    (id: ClickTargetId) => {
      props.onClick?.(id, props.event, contexts);
    },
    [contexts, props],
  );

  return (
    <NotificationsListItemDumb
      {...data}
      onButtonClick={onButtonClickCb}
      onClick={onClickCb}
      specificTestID={props.specificTestID || props.event.type}
      testID={props.testID || 'NotificationsListItem'}
    />
  );
};
